import { useCallback } from "react"

import { RJSFSchema } from "shared/types/RJSF"

import { filterFieldsWithSingleChoice } from "entities/dim-configuration/lib/filterFieldsWithSingleChoice"
import { filterSchemaProperties } from "entities/dim-configuration/lib/filterSchemaProperties"

interface UseProductConfigurationSchemaProcessorProps {
  hiddenAttributes?: string[]
  expertAttributes?: string[]
}

export type SchemaProcessor = ReturnType<
  typeof useProductConfigurationSchemaProcessor
>

export function useProductConfigurationSchemaProcessor({
  hiddenAttributes,
  expertAttributes
}: UseProductConfigurationSchemaProcessorProps) {
  return useCallback(
    ({
      schema: schemaForProcessing,
      filterExpertAttributes,
      filterHiddenAttributes,
      filterHidden = true,
      filterReadonly = false,
      filterSingleChoice = false,
      expertAttributes: expertAttributesFromArgs = expertAttributes,
      hiddenAttributes: hiddenAttributesFromArgs = hiddenAttributes
    }: {
      schema: RJSFSchema
      filterHiddenAttributes?: boolean
      filterExpertAttributes?: boolean
      filterReadonly?: boolean
      filterHidden?: boolean
      filterSingleChoice?: boolean
      hiddenAttributes?: string[]
      expertAttributes?: string[]
    }) =>
      filterSchemaProperties(
        schemaForProcessing,
        (field, id) =>
          (!filterExpertAttributes ||
            !expertAttributesFromArgs?.includes(id)) &&
          (!filterHiddenAttributes ||
            !hiddenAttributesFromArgs?.includes(id)) &&
          (!filterSingleChoice || !filterFieldsWithSingleChoice(field)) &&
          (!filterHidden || !field.isHidden) &&
          (!filterReadonly || !field.readOnly)
      ),
    [hiddenAttributes, expertAttributes]
  )
}
